
import React, { Component } from 'react';
import Spinner from './Spinner';

class CheckItem extends Component {
    constructor(props) {
        super(props);

        var mode = "";
        if (props.mode === "process") mode = "process";                // in this mode, a progress image will be shown when value === false

        this.state = {
            mode: mode
        };
    }

    render() {

        return <div>
            {!this.props.value &&
                <React.Fragment>
                    {this.state.mode === "process" &&
                        <Spinner></Spinner>}
                    {this.state.mode === "" &&
                        <span className="text-danger">&#10008;</span>
                    }
                </React.Fragment>
            }

            {this.props.value &&
                <span className="text-success">&#10003;</span>
            }
            <span className="ms-2">{this.props.label}</span>
        </div>
    }
}

export default CheckItem;